export function view(action) {
  if (action.id === 'letter' && action.document_id) {
    return 'LetterPredefined'
  } else if (action.id === 'letter' && !action.document_id) {
    return 'LetterNew'
  } else {
    return 'No'
  }
}
